import {Component, OnDestroy, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {SafeHtml} from '@angular/platform-browser';

export interface MessageDialogData {
  title: string;
  content?: string;
  name?: string;
  cancelLabel?: string;
  cancelMessage?: string;
  confirmLabel?: string;
  okayMessage?: string;
  buttonType?: string;
  hideConfirmButton?: boolean;
}

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.css'],
    standalone: false
})
export class MessageDialogComponent implements OnInit, OnDestroy {
    acceptClose: Subject<boolean> = new Subject();
    cancelClose: Subject<boolean> = new Subject();
    htmlContent: SafeHtml;

    constructor(public dialogRef: MatDialogRef<MessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MessageDialogData) {}

    ngOnInit() { }

    ngOnDestroy() { }

    confirmAction(boolean: boolean) {
        this.acceptClose.next(boolean);
        this.dialogRef.close(true);
    }
    cancelAction(boolean: boolean) {
        this.cancelClose.next(boolean);
        this.dialogRef.close(false);
    }
}
